import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import Routes from "./Components/Routes";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";

import { PersistGate } from "redux-persist/integration/react";
// import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { persistor, store } from "./Redux/store/store";

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <BrowserRouter>
        <PersistGate persistor={persistor} loading={false}>
          <Routes />
        </PersistGate>
      </BrowserRouter>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
